import { Article } from "@faire/help-center-utils/articles";

import { InstantAnswer } from "../types";

import { useSelectedNode } from "./useSelectedNode";

interface IUseSelectedNodeAnswer {
  hasInstantAnswer: boolean;
  instantAnswer: InstantAnswer | undefined;
  helpArticles: Article[];
  hasHelpArticles: boolean;
}

export const useSelectedNodeAnswer = (): IUseSelectedNodeAnswer => {
  const { level1Node, level2Node, level3Node, level4Node, level5Node } =
    useSelectedNode();
  const finalNode =
    level5Node || level4Node || level3Node || level2Node || level1Node;

  if (!finalNode) {
    return EMPTY_ANSWER();
  }

  const { instantAnswer, articles: helpArticles = [] } = finalNode;

  return {
    hasInstantAnswer: !!instantAnswer,
    instantAnswer,
    helpArticles,
    hasHelpArticles: helpArticles.length > 0,
  };
};

const EMPTY_ANSWER = () => ({
  hasInstantAnswer: false,
  instantAnswer: undefined,
  helpArticles: [],
  hasHelpArticles: false,
});
